import React from 'react';

export const DraggablePoint = ({ cx, cy, label, coords, onDrag, svgRef }) => {
  const handleMouseDown = (e) => {
    e.preventDefault();
    
    const svg = svgRef.current;
    const rect = svg.getBoundingClientRect();
    
    const handleMouseMove = (moveEvent) => {
      const newSvgX = (moveEvent.clientX - rect.left) * (400 / rect.width);
      const newSvgY = (moveEvent.clientY - rect.top) * (300 / rect.height);
      
      const newX = Math.max(0, Math.min(400, Math.round(newSvgX)));
      const newY = Math.max(0, Math.min(300, Math.round(newSvgY)));
      
      onDrag(newX, newY);
    };
    
    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <g>
      <circle 
        cx={cx} 
        cy={cy} 
        r="6" 
        fill="red" 
        stroke="darkred" 
        strokeWidth="2"
        style={{ cursor: 'move' }}
        onMouseDown={handleMouseDown}
      />
      <text x={cx + 8} y={cy - 8} fontSize="12" fill="red" fontWeight="bold">{label}</text>
      <text x={cx + 8} y={cy + 20} fontSize="10" fill="red">{coords}</text>
    </g>
  );
};

